import { ScheduledPremierServiceDTO } from "../DTO/scheduledPremierServiceDTO";

export class ScheduledPremierService{
    public premierServiceScheduleId!: number;
    public added!: Date;
    public customerPremierPartnerServiceConfigurationId!: number;
    public moovStepPremierServiceConfigurationId!: number;
    public customerId!: number;
    public clientId!: number;
    public executeOnOrAfter!: Date;
    public startedAt!: Date;
    public recurring!: boolean;
    public inProgress!: boolean;
    public addedByUserId!: number;
    public recurrenceType!: number;
    public recurrenceInterval!: number;
    public recurrenceDays!: number[];
    public recurrenceHour!: number;
    public recurrenceMinute!: number;
    public moovDefinitionId!: number;
    public moovConfigurationId!: number;
    public moovConfigurationFilenameStartsWith!: string;
    public moovConfigurationFilenameContains!: string;
    public premierServiceProductType!: string;
    public premierPartnerId!: number;

    public customerName!: string;
    public clientName!: string;
    public moovDefinitionName!: string;
    public premierPartnerName!: string;

    get moovConfigurationDescription(){
        return this.moovConfigurationFilenameStartsWith + ' (' + (this.moovConfigurationFilenameContains?this.moovConfigurationFilenameContains:'') +')';
    }

    get premierServiceDescription(){
        return this.premierPartnerName + ' (' + this.premierServiceProductType + ')';
    }

    constructor(){
    }

    public static mapFromDTO(param:ScheduledPremierServiceDTO):ScheduledPremierService{
        if(!param) throw new Error("parameter is null")
        let obj = new ScheduledPremierService();
        try
        {
            obj.premierServiceScheduleId = param.premierServiceScheduleId;
            if(param.added)obj.added = new Date(param.added);
            obj.customerPremierPartnerServiceConfigurationId = param.customerPremierPartnerServiceConfigurationId;
            obj.moovStepPremierServiceConfigurationId = param.moovStepPremierServiceConfigurationId;
            obj.customerId = param.customerId;
            obj.clientId = param.clientId;
            obj.executeOnOrAfter = new Date(param.executeOnOrAfter);
            if(param.startedAt)obj.startedAt = new Date(param.startedAt);
            obj.recurring = param.recurring;
            obj.inProgress = param.inProgress;
            obj.addedByUserId = param.addedByUserId;
            obj.recurrenceType = param.recurrenceType;
            obj.recurrenceInterval = param.recurrenceInterval;
            if(param.recurrenceDays) obj.recurrenceDays = param.recurrenceDays.split(',').map(Number);
            obj.recurrenceHour = param.recurrenceHour;
            obj.recurrenceMinute = param.recurrenceMinute;
            obj.moovDefinitionId = param.moovDefinitionId;
            obj.moovConfigurationId = param.moovConfigurationId;
            obj.moovConfigurationFilenameStartsWith = param.moovConfigurationFilenameStartsWith;
            obj.moovConfigurationFilenameContains = param.moovConfigurationFilenameContains;
            obj.premierServiceProductType = param.premierServiceProductType;
            obj.premierPartnerId = param.premierPartnerId;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:ScheduledPremierService):ScheduledPremierServiceDTO{
        if(!param) throw new Error("parameter is null")
        let dto = new ScheduledPremierServiceDTO();
        try
        {
            dto.premierServiceScheduleId = param.premierServiceScheduleId;
            if(param.added)dto.added = param.added.toISOString();
            dto.customerPremierPartnerServiceConfigurationId = param.customerPremierPartnerServiceConfigurationId;
            dto.moovStepPremierServiceConfigurationId = param.moovStepPremierServiceConfigurationId;
            dto.customerId = param.customerId;
            dto.clientId = param.clientId;
            dto.executeOnOrAfter = param.executeOnOrAfter.toISOString();
            if(param.startedAt)dto.startedAt = param.startedAt.toISOString();
            dto.recurring = param.recurring;
            dto.inProgress = param.inProgress;
            dto.addedByUserId = param.addedByUserId;
            dto.recurrenceType = param.recurrenceType;
            dto.recurrenceInterval = param.recurrenceInterval;
            if(param.recurrenceDays) dto.recurrenceDays = param.recurrenceDays.toString();
            dto.recurrenceHour = param.recurrenceHour;
            dto.recurrenceMinute = param.recurrenceMinute;
            dto.moovDefinitionId = param.moovDefinitionId;
            dto.moovConfigurationId = param.moovConfigurationId;
            dto.moovConfigurationFilenameStartsWith = param.moovConfigurationFilenameStartsWith;
            dto.moovConfigurationFilenameContains = param.moovConfigurationFilenameContains;
            dto.premierServiceProductType = param.premierServiceProductType;
            dto.premierPartnerId = param.premierPartnerId;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
}